import { PubSub } from './pub-sub';
import { clearSessionInfo, getSessionInfo, resetAutomaticallyLoggedOut, setIsInitialized, setSessionInfo, } from './session-store';
const HTTP_STATUS_NOT_LOGGED_IN = 401;
let callosumAPI = null;
export const initSessionService = (callosumAPIInstance) => {
    callosumAPI = callosumAPIInstance;
};
export const onUserLoggedIn = new PubSub();
export const onUserLoggedOut = new PubSub();
export const onThirdPartyServicesInitiated = new PubSub();
export const getOnUserLoggedOut = () => onUserLoggedOut;
export const fetchSessionInfo = () => {
    return callosumAPI.execute({
        path: '/session/info',
        method: 'GET',
    });
};
export const isSessionActive = () => {
    return callosumAPI.execute({
        path: '/session/isactive',
        method: 'GET',
    });
};
function userAuthenticated(sessionInfo, isExplicitLogin) {
    setSessionInfo(sessionInfo);
    resetAutomaticallyLoggedOut();
    if (isExplicitLogin) {
        onUserLoggedIn.publish();
    }
}
function isValidGuid(string) {
    const guidRegexp = /^[a-fA-F0-9]{8}-([a-fA-F0-9]{4}-){3}[a-fA-F0-9]{12}$/;
    if (!string || typeof string !== 'string' || !guidRegexp.test(string)) {
        return false;
    }
    return true;
}
function isValidSession(sessionInfo) {
    if (!sessionInfo ||
        !sessionInfo.userGUID ||
        !isValidGuid(sessionInfo.userGUID)) {
        return false;
    }
    return true;
}
export function handleLoginResponse(response) {
    const sessionInfo = response;
    if (isValidSession(sessionInfo)) {
        userAuthenticated(sessionInfo, true);
        return Promise.resolve(response);
    }
    return Promise.reject(response);
}
export const doLogin = (username, password, rememberme) => {
    return callosumAPI
        .execute({
        path: '/session/login',
        method: 'POST',
        postParamsJson: {
            username,
            password,
            rememberme: !!rememberme,
        },
    })
        .then(handleLoginResponse);
};
export const doShortLivedLogin = (userId, authToken) => {
    return callosumAPI
        .execute({
        path: '/session/shortlivedlogin',
        method: 'POST',
        postParamsJson: {
            id: userId,
            shortlivedauthenticationtoken: authToken,
        },
    })
        .then(handleLoginResponse);
};
export const doLogout = () => {
    return callosumAPI
        .execute({
        path: '/session/logout',
        method: 'POST',
    })
        .then(response => {
        clearSessionInfo();
        onUserLoggedOut.publish();
        return response;
    });
};
export const authenticate = () => {
    return fetchSessionInfo()
        .then(response => {
        const sessionInfo = response.data;
        setIsInitialized();
        if (isValidSession(sessionInfo)) {
            userAuthenticated(sessionInfo);
            return Promise.resolve();
        }
        setSessionInfo(sessionInfo);
        throw Promise.reject();
    })
        .catch(error => {
        setIsInitialized();
        if (error.status === HTTP_STATUS_NOT_LOGGED_IN) {
            setSessionInfo(error.data);
        }
        throw Promise.reject(error);
    });
};
export const saveClientState = (clientState) => {
    const clientStateJSON = clientState ? JSON.stringify(clientState) : '{}';
    const userId = getSessionInfo().userGUID;
    if (!callosumAPI) {
        return Promise.reject('Callosum API not initialized');
    }
    return callosumAPI.execute({
        path: '/session/user/saveclientstate',
        method: 'POST',
        postParamsJson: {
            userid: userId,
            clientstate: clientStateJSON,
        },
    });
};
export const flagMixpanelDNT = (params) => {
    return callosumAPI.execute({
        path: '/session/mixpaneldnt',
        method: 'GET',
        getParamsJson: params,
    });
};
//# sourceMappingURL=session-api.js.map